import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  FormControl,
  Grid,
  GridList,
  GridListTile,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
  Select,
  Tab,
  Tabs,
  Table,
  TableRow,
  TableCell,
  TableSortLabel,
  TableHead,
  TableBody,
  TablePagination,
  TextField

} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import Settings from "../../provider/base/Settings"
import { actionGetStatsByClient } from "../../actions/StatsActions"
import { actionGetPlaces } from "../../actions/PlaceActions"
import { actionGetStatsByClientDetail } from "../../actions/StatsActions"

import moment from "moment"

import SearchIcon from '@material-ui/icons/Search';
// import ClearIcon from '@material-ui/icons/Backspace';
import RefreshIcon from '@material-ui/icons/Sync';
import DetailIcon from '@material-ui/icons/List';
import StatsByClientTab from "./StatsByClientTab"
import StatsByClientDetail from "./StatsByClientDetail"
import StatsByEventTab from "./StatsByEventTab"


let _handleSubmitFail;
class Statistics extends React.PureComponent{
  constructor(props){
    super(props)
    let lastMonth = moment()
    lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
    let today = moment().format("YYYY-MM-DD")
    let filter = {from:lastMonth, to:today, period:"daily", place:""}
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"Qt", orderDesc:true, filter:filter, tabIndex:0, detailInitFilter:null}
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.sortStatsByClient = this.sortStatsByClient.bind(this)
    this.onFilterDate = this.onFilterDate.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.onChangeTab = this.onChangeTab.bind(this)
    this.onPressDetailUser = this.onPressDetailUser.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);      
    }else{
      this.onRefresh()
      this.props.actionGetPlaces(null,this.getPlacesError)
    }
  }

  getStatsByClientError(e){
    console.log("ERROR GET STATS BY CLIENT", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las estadísticas por cliente.")
  }

  getPlacesError(e){
    console.log("ERROR GET Places", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las ubicaciones.")
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onRefresh(){
    const {orderBy, orderDesc, filter} = this.state
    let order = {orderBy:orderBy, orderDesc:orderDesc}
    this.props.actionGetStatsByClient(filter, order, this.onChangePage, this.getStatsByClientError)
  }

  onSortByField(field){
    if(field == this.state.orderBy){
      this.setState({orderDesc:!this.state.orderDesc}, this.onChangePage)
    }else{
      this.setState({orderBy:field}, this.onChangePage)
    }
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let users = this.props.statsByClient //.filter(this.filterUsers)
    
    const count = users.length
    users = users.sort(this.sortStatsByClient)
    users = users.slice(from, end)
    this.setState({page:newPage, count:count, users:users})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let users = this.props.statsByClient //.filter(this.filterUsers)
    const count = users.length
    users = users.sort(this.sortStatsByClient)
    users = users.slice(from, end)
    this.setState({rowPerPage:evt.target.value, users:users})
  }

  sortStatsByClient(a,b){
    try{
      
      if(b[this.state.orderBy]&&!a[this.state.orderBy]){
        return 1
      }
      if(!b[this.state.orderBy]&&a[this.state.orderBy]){
        return -1
      }
      if(!b[this.state.orderBy]&&!a[this.state.orderBy]){
        return 0
      }
    }catch(e){
      console.log("SORT STATS BY CLIENT ERROR", e)
      return -1
    }
  }

  onChangeFilter(field, evt){
    console.log("ON CHANGE FILTER DATE", evt.target.value, field)
    let filter = {...this.state.filter}
    filter[field] = evt.target.value
    this.setState({filter:filter})
  }

  onFilterDate(){
    if(this.state.filter&&this.state.filter.from&&this.state.filter.to){
      this.onRefresh()
    }
  }
  
  onChangeTab(evt, value){
		this.setState({tabIndex:value, page:0}); 
	}

  onPressDetailUser(user, filter){
    this.props.actionGetStatsByClientDetail({...filter, tktBuyerDU:user.tktBuyerDU}, {}, ()=>{
      this.setState({detailUser:user, detailInitFilter:filter})
    },
    (e)=>{
      console.log("ERROR GET Places", e)
      if(!(e&&e.status&&e.status==401))
        Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    })
    
  }
  renderTableHeader(){
    const {theme} = this.props
    const headers = [{id:"tktBuyerLastName",label:"Apellido y Nombre"}, 
                     {id:"tktBuyerDU",label:"DNI"},
                     {id:"Qt", label:"Cantidad"},
                     {id:"Total", label:"Total $"},
                     {id:"TotalProducer", label:"Total $ Productor"}]
                     
    // if(Settings.IS_USER_VERIFIED){
    //   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})

    // }
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
        if(headCell.id == "tktBuyerDU"||headCell.id == "tktBuyerLastName"){
          return (
            <TableCell> {headCell.label}</TableCell>
          )
        }
        return (
          <TableCell>
            <TableSortLabel
            active={this.state.orderBy === headCell.id}
            direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
            onClick={()=>this.onSortByField(headCell.id)}
            hideSortIcon={true}>
              {headCell.label}
            </TableSortLabel>  
          </TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let users = this.state.users
    if(!users||users.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return users.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          {/* {Settings.IS_USER_VERIFIED&&<TableCell>{item.proInstagram}</TableCell>} */}
         <TableCell>{`${item.tktBuyerLastName}, ${item.tktBuyerName}`}</TableCell>
          <TableCell>{item.tktBuyerDU}</TableCell>
          <TableCell>{item.Qt}</TableCell>
          <TableCell>{item.Total}</TableCell>
          <TableCell>{item.TotalProducer}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
           
            <Tooltip title="Ver Detalle">
              <IconButton onClick={this.onDetailUser.bind(this, item)}>
                <DetailIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }
  

  render(){
    const { theme, handleSubmit, history, placeList} = this.props
    const { detailUser,detailInitFilter } = this.state
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Estadísticas</Typography>
            
          </Box>
        </Box>
        <Container maxWidth={1320}>        
          <Tabs indicatorColor="primary" value={this.state.tabIndex} onChange={this.onChangeTab}>
            <Tab label="Por Cliente" />
            <Tab label="Por Evento"/>
          </Tabs>
          {this.state.tabIndex==0&&<StatsByClientTab onPressDetail={this.onPressDetailUser}/>}
          {this.state.tabIndex==1&&<StatsByEventTab/>}
        </Container>
        <StatsByClientDetail 
                            user={detailUser}
                            filter={detailInitFilter}
                            onClose={()=>{console.log("ONCLOSE");this.setState({detailUser:null,detailInitFilter:null})}}/>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  console.log("STORE STATISTICS", store)
  return {
    login: store.auth.login,
    statsByClient:store.stats.statsByClient,
    placeList: store.plc.placeList

   
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByClient,
      actionGetStatsByClientDetail,
      actionGetPlaces
    },
    dispatch
  );
}

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(Statistics)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/Statistics.js